import React from 'react'

const HeaderPubs = (props) => (
    <header id="header" className="alt header-comp">
        <h1>The Best Pubs for Traditional Irish Music</h1>
        <p>The pub continues to have a central role in Irish culture and society.</p>
    </header>
)

export default HeaderPubs



// WEBPACK FOOTER //
// ./src/components/HeaderPubs.js